// ACTIONS
export const ORGANIZATION_GET = 'ORGANIZATION_GET';
export const ORGANIZATION_GET_SUCCEEDED = 'ORGANIZATION_GET_SUCCEEDED';
export const ORGANIZATION_GET_FAILED = 'ORGANIZATION_GET_FAILED';

export const ORGANIZATION_GET_FEATURE_FLAGS = 'ORGANIZATION_GET_FEATURE_FLAGS';
export const ORGANIZATION_GET_FEATURE_FLAGS_SUCCEEDED =
  'ORGANIZATION_GET_FEATURE_FLAGS_SUCCEEDED';
export const ORGANIZATION_GET_FEATURE_FLAGS_FAILED =
  'ORGANIZATION_GET_FEATURE_FLAGS_FAILED';

export const ORGANIZATION_EDIT = 'ORGANIZATION_EDIT';
export const ORGANIZATION_EDIT_SUCCEEDED = 'ORGANIZATION_EDIT_SUCCEEDED';
export const ORGANIZATION_EDIT_FAILED = 'ORGANIZATION_EDIT_FAILED';

export const ORGANIZATION_GET_PRESIGNED = 'ORGANIZATION_GET_PRESIGNED';
export const ORGANIZATION_GET_PRESIGNED_SUCCEEDED =
  'ORGANIZATION_GET_PRESIGNED_SUCCEEDED';
export const ORGANIZATION_GET_PRESIGNED_FAILED =
  'ORGANIZATION_GET_PRESIGNED_FAILED';

export const ORGANIZATION_UPLOAD_AVATAR = 'ORGANIZATION_UPLOAD_AVATAR';
export const ORGANIZATION_UPLOAD_AVATAR_SUCCEEDED =
  'ORGANIZATION_UPLOAD_AVATAR_SUCCEEDED';
export const ORGANIZATION_UPLOAD_AVATAR_FAILED =
  'ORGANIZATION_UPLOAD_AVATAR_FAILED';

// FORM UPDATES
export const ORGANIZATION_CHANGE_DEFAULT_NUMBER =
  'ORGANIZATION_CHANGE_DEFAULT_NUMBER';

// EXTERNAL
export const ORGANIZATION_LOADED = 'ORGANIZATION_LOADED';
